import React from "react";
import { MessageSquare } from "lucide-react";

interface EmptyStateProps {
  onExampleClick: (query: string) => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onExampleClick }) => {
  const exampleQueries = [
    "What are the key findings in the latest research report?",
    "Summarize the safety protocols from the lab manual",
    "What are the temperature requirements for sample storage?",
    "Explain the validation criteria for test results",
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="mb-6">
        <MessageSquare className="w-16 h-16 text-text-faint mx-auto" />
      </div>

      <h2 className="text-2xl font-semibold text-text-muted mb-3">
        Ask a Question
      </h2>

      <p className="text-text-faint mb-8 max-w-md">
        Ask questions about your documents and get answers with citations from
        the source material.
      </p>

      <div className="w-full max-w-2xl">
        <p className="text-sm text-text-muted mb-4 font-medium">
          Try these examples:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {exampleQueries.map((query, index) => (
            <button
              key={index}
              onClick={() => onExampleClick(query)}
              className="p-4 text-left bg-surface border border-subtle rounded-lg hover:border-accent hover:shadow-md transition-all duration-200 text-sm text-text-muted"
            >
              {query}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
